import styled from 'styled-components'

const ProductName = styled.div`
  margin-bottom: 10px;

  sup {
    font-weight: ${props => props.theme.font.weight.bold};
  }

  span {
    margin-right: 5px;
  }
`

const Main = styled.h1`
  display: inline;
  line-height: 1;
  margin: 0;

  div {
    display: inline-block;
  }
`

const CatNumber = styled.span`
  font-weight: ${props => props.theme.font.weight.bold};
  font-size: ${props => props.theme.font.size.base};
  color: ${props => props.theme.color.monochrome.dark};
  white-space: nowrap;
`

export { ProductName, Main, CatNumber }
